import { z } from "zod";

export const ReportReasonSchema = z.enum([
  "incorrect_information",
  "missing_information",
  "inappropriate_content",
  "access_issue",
  "safety_concern",
  "other",
]);

export const ReportStatusSchema = z.enum([
  "open",
  "acknowledged",
  "in_progress",
  "resolved",
  "dismissed",
]);

export const ReportedContentTypeSchema = z.enum(["areas", "models", "routes"]);

export const ReportStatusHistoryEntrySchema = z.object({
  status: ReportStatusSchema,
  updated_at: z.iso.datetime(),
  updated_by: z.string().nullable(),
  note: z.string().nullable().optional(),
});

export const ContentReportSchema = z.object({
  id: z.string().uuid(),
  reporter_id: z.string().nullable(),
  content_type: ReportedContentTypeSchema,
  content_id: z.string().uuid(),
  area_id: z.string().uuid().nullable(),
  model_id: z.string().uuid().nullable(),
  route_id: z.string().uuid().nullable(),
  team_id: z.string().uuid().nullable(),
  reason: ReportReasonSchema,
  description: z.string().min(5),
  status: ReportStatusSchema,
  resolution_notes: z.string().nullable(),
  metadata: z.record(z.string(), z.unknown()).nullable(),
  status_history: z.array(ReportStatusHistoryEntrySchema),
  created_at: z.iso.datetime(),
  updated_at: z.iso.datetime(),
  resolved_at: z.iso.datetime().nullable(),
});

export const CreateContentReportSchema = z.object({
  content_type: ReportedContentTypeSchema,
  content_id: z.string().uuid(),
  area_id: z.string().uuid().nullable().optional(),
  model_id: z.string().uuid().nullable().optional(),
  route_id: z.string().uuid().nullable().optional(),
  reason: ReportReasonSchema,
  description: z
    .string()
    .min(10, "report.descriptionTooShort")
    .max(2000, "report.descriptionTooLong"),
  metadata: z.record(z.string(), z.unknown()).optional(),
});

export const UpdateContentReportSchema = z.object({
  status: ReportStatusSchema.optional(),
  resolution_notes: z
    .string()
    .max(2000, "report.resolutionNotesTooLong")
    .nullable()
    .optional(),
});

export const ContentReportListSchema = z.object({
  reports: z.array(ContentReportSchema),
  total: z.number().int().nonnegative(),
  limit: z.number().int().positive(),
  offset: z.number().int().nonnegative(),
});
